import {
  disconnectMerchantStoreBindingResponseSchema,
  merchantStoreBindingsResponseSchema,
} from "@/features/settings/storeManagementSchemas";
import { baseApi } from "@/shared/api/baseApi";

interface DisconnectMerchantStoreBindingInput {
  bindingId: string;
  expectedRevision: string;
  organizationId: string;
}

export const storeManagementApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    disconnectMerchantStoreBinding: builder.mutation<
      ReturnType<typeof disconnectMerchantStoreBindingResponseSchema.parse>,
      DisconnectMerchantStoreBindingInput
    >({
      invalidatesTags: (_result, _error, input) => [
        { id: input.organizationId, type: "MerchantStoreBindings" },
        "CapabilityReadiness",
      ],
      query: ({ bindingId, expectedRevision, organizationId }) => ({
        body: { expected_revision: Number(expectedRevision) },
        method: "DELETE",
        url: `/v1/organizations/${encodeURIComponent(organizationId)}/merchant-store-bindings/${encodeURIComponent(bindingId)}`,
      }),
      transformResponse: (response) =>
        disconnectMerchantStoreBindingResponseSchema.parse(response),
    }),
    getMerchantStoreBindings: builder.query<
      ReturnType<typeof merchantStoreBindingsResponseSchema.parse>,
      string
    >({
      providesTags: (_result, _error, organizationId) => [
        { id: organizationId, type: "MerchantStoreBindings" },
      ],
      query: (organizationId) =>
        `/v1/organizations/${encodeURIComponent(organizationId)}/merchant-store-bindings`,
      transformResponse: (response) =>
        merchantStoreBindingsResponseSchema.parse(response),
    }),
  }),
});

export const {
  useDisconnectMerchantStoreBindingMutation,
  useGetMerchantStoreBindingsQuery,
} = storeManagementApi;
